var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.37524V11.3752C0 11.8585 0.447693 12.2502 1 12.2502H4V3.50024H1C0.447693 3.50024 0 3.89198 0 4.37524Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1533 4.37494H11.1992C10.9409 4.37494 10.8115 4.22412 10.7681 4.15918C10.7246 4.09467 10.6367 3.92249 10.7617 3.7251L11.8032 2.08404C12.0317 1.72473 12.0552 1.30218 11.8682 0.924923C11.6812 0.547238 11.312 0.273372 10.8555 0.173824L10.1211 0.0131797C9.94238 -0.026127 9.75293 0.0238609 9.62842 0.144772L5.64111 4.02075C5.22754 4.42364 5 4.94318 5 5.48407V10.0624C5 11.2686 6.12158 12.2499 7.5 12.2499L12.4741 12.2495C13.5972 12.2495 14.5889 11.5877 14.8853 10.6405L15.9526 6.35436C15.9839 6.23516 16 6.11297 16 5.99077C16 5.09996 15.1714 4.37493 14.1533 4.37493L14.1533 4.37494Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.798625b81e49d7fe29721646f70330a9.svg";
export { ForwardRef as ReactComponent };